import { IonButtons, IonIcon } from "@ionic/react";
import { cart, cartOutline, heart, heartOutline } from "ionicons/icons";
import { Link } from "react-router-dom";
import { useCart } from "../../pages/Cart/useCart";
import { usePictures } from "../../pages/Pictures/usePictures";

const baseBadgeStyle: React.CSSProperties = {
  position: "absolute",
  top: -6,
  right: -8,
  color: "#fff",
  borderRadius: "50%",
  width: 18,
  height: 18,
  fontSize: 11,
  fontWeight: 700,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: 1,
};

const ToolbarIcons = () => {
  const { favorites } = usePictures();
  const { cartCount } = useCart();

  return (
    <>
      <IonButtons slot="end" style={{ paddingRight: 15 }}>
        <Link
          to={{ pathname: "/omiljene" }}
          style={{ textDecoration: "none", color: "#fff", position: "relative" }}
        >
          <IonIcon
            icon={favorites.length > 0 ? heart : heartOutline}
            style={{ fontSize: 28 }}
          />
          {favorites.length > 0 && (
            <span style={{ ...baseBadgeStyle, background: "var(--ion-color-medium)" }}>{favorites.length}</span>
          )}
        </Link>
      </IonButtons>
      <IonButtons slot="end" style={{ paddingRight: 15 }}>
        <Link
          to={{ pathname: "/korpa" }}
          style={{ textDecoration: "none", color: "#fff", position: "relative" }}
        >
          <IonIcon
            icon={cartCount > 0 ? cart : cartOutline}
            style={{ fontSize: 28 }}
          />
          {cartCount > 0 && (
            <span style={{ ...baseBadgeStyle, background: "var(--ion-color-danger)" }}>{cartCount}</span>
          )}
        </Link>
      </IonButtons>
    </>
  );
};

export default ToolbarIcons;
